<template>
	<v-card-text>
		<step :step="step" />
		<v-row v-if="success" class="mt-5">
			<v-col cols="8" sm="9"
				>Pairing successful! Click next to continue...</v-col
			>
		</v-row>
		<v-row v-else-if="busy && !pairing" class="mt-5">
			<v-progress-linear indeterminate />
			<v-col cols="8" sm="9">Waiting to connect...</v-col>
		</v-row>
		<v-row v-else-if="pairing" class="mt-5">
			<v-progress-linear indeterminate />
			<v-col cols="12"
				>Waiting for device to pair...<br />(This can take up to two
				minutes.)</v-col
			>
		</v-row>
		<v-row v-else class="mt-5">
			<v-col cols="8" sm="9">
				Enter device serial number (DSN) to begin pairing:
			</v-col>
			<v-col cols="4" sm="3" />
			<v-col cols="9" sm="9">
				<v-text-field
					v-model="dsn"
					:rules="dsnRules"
					label="16-Digit Device Serial Number"
					placeholder="XXXXXXXXXXXXXXXX"
				/>
			</v-col>
			<v-col cols="4" sm="3" align-self="center">
				<v-btn text color="primary" :disabled="!validDSN" @click="doPair"
					>Pair</v-btn
				>
			</v-col>
		</v-row>
	</v-card-text>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

import cloud from "@/api/cloud";

import Step from "../Step";
import stepBase from "../../extends/step";

function validDSN(dsn) {
	return _.isString(dsn) && !_.isNull(dsn.match(/^[A-Za-z0-9]{16}$/));
}

export default {
	components: {
		Step,
	},

	mixins: [stepBase],

	props: {
		step: Object,
	},

	data: () => ({
		success: false,
		pairing: false,
		stepNumber: 2,

		dsn: null,
		// TODO: Does DSN follow any alpha-numeric pattern?
		dsnRules: [v => validDSN(v) || "16 alpha-numeric characters"],
	}),

	computed: {
		validDSN() {
			return validDSN(this.dsn);
		},

		session() {
			return {
				community: this.$store.getters["session/community"].name,
				system: this.$store.getters["session/system"].name,
			};
		},
	},

	methods: {
		...mapGetters({ nodeByGuid: "controller/nodes/nodeByGuid" }),
		...mapActions({ setNodeProperty: "controller/nodes/setProperty" }),

		async start() {
			// Do nothing to start with. Wait for user to enter DSN and hit "Pair" button instead.
		},

		async doPair() {
			// Already paired
			if (this.success) return;

			// Already pairing
			if (this.busy) return;

			this.setBusy(true);
			this.setDisableNext(true);

			try {
				// start the pairing
				this.pairing = true;

				this.$log(`Alexa Wizard: Starting pair ${this.device.path}`);

				await cloud.attachA4HDevice(
					this.dsn,
					this.session.community,
					this.session.system
				);
			} catch (e) {
				return this.handleError(e);
			} finally {
				this.pairing = false;
			}

			try {
				await this.setNodeProperty({
					nodeGuid: this.device.meta ? this.device.meta.guid : this.device.guid,
					propName: "dsn",
					propValue: this.dsn,
				});

				this.success = true;
				this.$log(
					`Alexa Wizard: Pairing completed for ${this.device.path} with DSN ${this.dsn}`
				);
				this.success = true;
				this.setDisableNext(false);
			} catch (e) {
				return this.handleError(e);
			}

			this.setBusy(false);
		},

		handleError(e) {
			let errorMessage = e;
			if (_.isError(e)) errorMessage = e.message;
			else if (_.isObject(e)) errorMessage = JSON.stringify(e);

			this.$log(
				`Alexa Wizard: Pairing failed for ${this.device.path} with error ${errorMessage}`
			);
			return this.showError("Pairing failed. Check entered DSN and try again.");
		},
	},
};
</script>
